// assets/vm-heat-hover.js (lane L3, v5.3): <vm-card-tile>, the product card tile (snippets/vm-heat-hover.liquid).
// The on-body image and the heat plate wait in <template>s. The first mouse hover (hover:hover only)
// clones the hover image in (an <img>, or a packshot <img> in its .vm-tile__pack <span>); the heat view (html[data-vm-view="heat"], set by vm-view-switch.js)
// clones the plate in (an <img>, or a <picture> with the no-label phone plate). Nothing downloads before
// that. Touch never loads the hover image.
// v6 hover heat (9 Oct 2026; owner "hover heat yes"): a tile with data-vm-glow (its photo is listed in
// snippets/vm-glow-map.liquid) has no hover template. On a mouse hover or keyboard focus of the card (hover:hover
// only; no glow and no button on phones) it imports assets/vm-glow.js (data-vm-glow-js), which fades the glow in
// on this same photo with the "Illustrated heated zones" label; leaving fades it out. Nothing loads before that.
const FINE = matchMedia('(hover: hover) and (pointer: fine)');

class VmCardTile extends HTMLElement {
  connectedCallback() {
    if (FINE.matches && !this.vmCard) {
      const card = (this.vmCard = this.closest('product-card') || this);
      // Read at event time: a filtered grid can morph this tile into another product's.
      const go = (why, on) => {
        const js = this.dataset.vmGlow && this.dataset.vmGlowJs;
        if (js) import(js).then((m) => m.glow(this, why, on), () => {});
        else if (on && why === 'hover') this.load('hover');
      };
      card.addEventListener('pointerenter', (e) => e.pointerType !== 'touch' && go('hover', true));
      card.addEventListener('pointerleave', (e) => e.pointerType !== 'touch' && go('hover', false));
      card.addEventListener('focusin', (e) => e.target.matches?.(':focus-visible') && go('focus', true));
      card.addEventListener('focusout', (e) => card.contains(e.relatedTarget) || go('focus', false));
    }
    if (document.documentElement.dataset.vmView === 'heat') this.load('plate');
  }

  load(kind) {
    const tpl = this.querySelector(`template[data-vm-${kind}]`);
    const frag = tpl && tpl.content.cloneNode(true);
    const node = frag && frag.querySelector('img');
    if (!node) return;
    tpl.remove();
    const layer = node.closest('.vm-tile__layer') || node;
    const done = () => layer.setAttribute('data-loaded', '');
    const ready = () => (node.decode ? node.decode().catch(() => {}) : Promise.resolve()).then(done);
    node.addEventListener('load', ready, { once: true });
    this.append(frag);
    if (node.complete && node.naturalWidth) ready();
  }
}

if (!customElements.get('vm-card-tile')) customElements.define('vm-card-tile', VmCardTile);
